import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';

export default function TotalsSummary({ liquidaciones }) {
  const totals = liquidaciones.reduce((acc, liquidacion) => {
    acc.total_facturas += parseFloat(liquidacion.total_facturas || 0);
    acc.total_credito += parseFloat(liquidacion.total_credito || 0);
    acc.total_devoluciones += parseFloat(liquidacion.total_devoluciones || 0);
    acc.total_diferencias += parseFloat(liquidacion.diferencia || 0);
    return acc;
  }, {
    total_facturas: 0,
    total_credito: 0,
    total_devoluciones: 0,
    total_diferencias: 0
  });

  return (
    <Card style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={6}>
          <Statistic
            title="Total Facturas"
            value={totals.total_facturas}
            precision={2}
            prefix="$"
          />
        </Col>
        <Col span={6}>
          <Statistic
            title="Total Crédito"
            value={totals.total_credito}
            precision={2}
            prefix="$"
          />
        </Col>
        <Col span={6}>
          <Statistic
            title="Total Devoluciones"
            value={totals.total_devoluciones}
            precision={2}
            prefix="$"
          />
        </Col>
        <Col span={6}>
          <Statistic
            title="Total Diferencias"
            value={totals.total_diferencias}
            precision={2}
            prefix="$"
            valueStyle={{ color: totals.total_diferencias < 0 ? '#cf1322' : '#3f8600' }}
          />
        </Col>
      </Row>
    </Card>
  );
}